export function getUserDisplayName(user, returnEmail = true) {
  if (user.firstName) {
    return `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}`;
  }

  if (returnEmail && user.email) {
    return user.email;
  }

  return '';
}
